import { render, staticRenderFns } from "./OrderDetailsModal.vue?vue&type=template&id=b91ddb8c&scoped=true"
import script from "./OrderDetailsModal.vue?vue&type=script&lang=js"
export * from "./OrderDetailsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b91ddb8c",
  null
  
)

export default component.exports